export default __webpack_public_path__ + "static/media/landingBg.12364ab5.jpg";